import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Box from '@mui/material/Box';
import 'dayjs/locale/en';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import './datepicker.scss';
import { InputLabel, TextField } from '@mui/material';
import { CHOOSE_DATE } from '../../Constants/strings';
import { ReactComponent as CustomDatePickerIcon } from '../../Assets/images/svg/dar_calendar_blank_gray.svg';
import { styled } from '@mui/material/styles';

// Styled components
const StyledBox = styled(Box)({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
});

const StyledDatePicker = styled(MuiDatePicker)(({ isDisabled }) => ({
  width: 260,
  '& .MuiInputBase-root': {
    backgroundColor: isDisabled ? '#f5f5f5' : '',
  },
  '& .MuiInputBase-input': {
    fontSize: '85%',
    opacity: 1,
    marginLeft: '-3%',
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#bcbebe',
    opacity: 1,
    fontSize: '100%',
    marginLeft: '20%',
  },
}));

const CommonDatePicker = ({
  value,
  onChange,
  label,
  placeholder,
  minDate,
  maxDate,
  isDisabled,
  error,
  helperText,
  displayFormat,
}) => {
  const themeColor = '#6b5ce8';
  return (
    <div className="certification-date-container">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <InputLabel className="datepicker-input-label">{label}</InputLabel>
        <StyledBox>
          <DemoItem>
            <StyledDatePicker
              minDate={minDate}
              maxDate={maxDate}
              value={value}
              onChange={onChange}
              format={displayFormat || undefined}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="custom-datepicker-input"
                  placeholder={CHOOSE_DATE}
                  error={error}
                  helperText={helperText}
                />
              )}
              slotProps={{
                field: {
                  placeholder: placeholder,
                },
                day: {
                  sx: {
                    '&.MuiPickersDay-root.Mui-selected': {
                      backgroundColor: themeColor,
                    },
                  },
                },
              }}
              slots={{ openPickerIcon: CustomDatePickerIcon }}
              disabled={isDisabled}
              isDisabled={isDisabled}
            />
          </DemoItem>
        </StyledBox>
      </LocalizationProvider>
    </div>
  );
};

CommonDatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  isDisabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  displayFormat: PropTypes.string,
};

export default CommonDatePicker;
